import { SCOrderListResponseType } from "@sellar-io/api-v2/types";
import {
  Badge,
  BadgeGreen,
  BadgeWhite,
  BadgeRed,
  BadgeZinc,
} from "../../../../../../components/badge/Badge";
import dayjs from "dayjs";

export const TabPaymentStatusBadge = ({
  order,
}: {
  order: SCOrderListResponseType[number];
}) => {
  const today = dayjs();
  const dispatched = dayjs(order.dispatchedAt);
  const dueDate = dispatched.endOf("month").add(30, "days");
  let status = "pending";

  if (order.dispatchedAt) {
    status = "added";
  }

  if (today.isAfter(dispatched.endOf("month"))) {
    status = "issued";
  }

  if (order.retailerPaidAt) {
    status = "paid";
  }

  if (
    today.isAfter(dueDate) &&
    today.isBefore(dayjs(dueDate).add(4, "days")) &&
    !order.retailerPaidAt
  ) {
    status = "processing";
  }

  if (today.isAfter(dayjs(dueDate).add(4, "days")) && !order.retailerPaidAt) {
    status = "overdue";
  }

  if (order.cancelledAt) {
    status = "cancelled";
  }

  switch (status) {
    case "added":
      return <Badge>Added to statement</Badge>;

    case "issued":
      return <BadgeZinc>Issued: Due {dueDate.format("MMM DD")}</BadgeZinc>;

    case "paid":
      return <BadgeGreen>Paid</BadgeGreen>;

    case "overdue":
      return <BadgeRed>Overdue</BadgeRed>;

    case "processing":
      return <BadgeZinc>Processing</BadgeZinc>;

    case "cancelled":
      return <BadgeZinc>Void</BadgeZinc>;

    case "pending":
    default:
      return <BadgeWhite>Pending</BadgeWhite>;
  }
};
